import axios from "./axiosConfig";
import { API_CONFIG } from "../utils/constants";

/**
 * Capa de servicios HTTP del buzón de notificaciones.
 * El backend responde { success, data, pagination, unread }.
 */
const notificationsService = {
  list(params = {}) {
    return axios.get("/notifications", {
      params: { type: "WEEKLY_CRM_SUMMARY", ...params },
    });
  },
  get(id) {
    return axios.get(`/notifications/${id}`);
  },
  markAllRead() {
    return axios.patch("/notifications/read-all");
  },

  htmlUrl(id) {
    return `${API_CONFIG.BASE_URL}/api/notifications/${id}/html`;
  },

  sendWeeklySummary(data = {}) {
    return axios.post("/notifications/weekly-summary/send", data);
  },
  previewWeeklySummary() {
    return axios.get("/notifications/weekly-summary/preview");
  },
};

export default notificationsService;
